import { PopupsSizeConfig } from '@gamiphy/bl/popups';
import { DisplayString } from '@gamiphy/i18n';
import {
  PopupDto,
  PopupDtoSizeEnum,
} from '@coretava/api/core-service';
import PopupButton from '@gamiphy/loyalty-station-desktop/components/promotion/PopupButton';
import { DisplayStringTrans } from '@gamiphy/react-i18n';
import {
  Box,
  Typography,
} from '@mui/material';
import React from 'react';
import CountDown from './CountDown';

const PopupContentBody: React.FC<{
  popup: PopupDto;
  isMobile: boolean;
  popupSizeConfig: PopupsSizeConfig;
  showBanner: boolean;
  i18nTagsValues: object;
  discountCode?: string;
  onClose: () => void;
 }> = ({
   popup,
   isMobile,
   popupSizeConfig,
   showBanner,
   i18nTagsValues,
   discountCode,
   onClose,
 }) => (
   <>
     <Box
       p={popupSizeConfig.padding}
       height="100%"
       display="flex"
       flexDirection="column"
       gap={(popup.size === PopupDtoSizeEnum.Small || isMobile) ? 1 : 2}
       justifyContent="space-between"
       textAlign="center"
       sx={{
         ...(!showBanner || !isMobile) && {
           pt: `calc(${popupSizeConfig.padding} + ${popupSizeConfig.closButtonSize})`,
         },
       }}
     >

       {
              popup.image?.url && (
                <Box component="img" src={popup.image?.url} maxWidth="80%" mx="auto" />
              )
            }
       {
              popup.subject && (
                <Typography
                  color={popup.colors.subject}
                  fontSize={popupSizeConfig.subjectFontSize}
                  fontWeight={600}
                  sx={popup.styles.subject}
                >
                  <DisplayStringTrans
                    displayString={popup.subject as DisplayString}
                    values={i18nTagsValues}
                  />
                </Typography>
              )
            }
       {
              popup.duration?.endDate && (
                <CountDown
                  fontSize={popupSizeConfig.subjectFontSize}
                  labelsFontSize={popupSizeConfig.bodyFontSize}
                  endDate={popup.duration?.endDate}
                />
              )
            }
       {
              popup.body && (
                <Typography
                  color={popup.colors.body}
                  fontSize={popupSizeConfig.bodyFontSize}
                  sx={popup.styles.body}
                >
                  <DisplayStringTrans
                    displayString={popup.body as DisplayString}
                    values={i18nTagsValues}
                  />
                </Typography>
              )
            }

     </Box>
     <Box p={popupSizeConfig.padding} bgcolor="#fff">
       <PopupButton
         padding={popupSizeConfig.buttonPadding}
         fontSize={popupSizeConfig.buttonFontSize}
         borderRadius={popupSizeConfig.buttonBorderRadius}
         popup={popup}
         discountCode={discountCode}
         closePopup={onClose}
       />
     </Box>
   </>
 );

export default PopupContentBody;
